/**
 * Created by eliranm on 27/10/14.
 */
define(function (require) {
    'use strict';

    var _ = require('underscore');
    var Config = require('ui/file-upload-input/config/fileUploadInputConfig.json');
    var logger = require('logger').getLogger(Config.loggerNamespace);

    return {


        /**
         * Prepends the passed value to each item in the passed array. This function only handles string values,
         * other types in the array will be ignored.
         * @param arr The array.
         * @param val A value to prepend to each item. If the value is not of type string, it is converted to a string
         * and concatenated as such.
         * @returns {*} The modified array.
         */
        prependEach: function (arr, val) {
            if (!arr || !_.isArray(arr)) {
                this._fail('arr must exist and be of type Array');
            }
            if (!val) {
                this._fail('val must exist');
            }
            val += '';
            return _.map(arr, function (v) {
                if (!_.isString(v)) {
                    return v;
                }
                return val + v;
            });
        },

        /**
         * Assigns own enumerable properties of source object to the destination object for all destination properties
         * that resolve to undefined.
         * @param dest
         * @param src
         * @returns {*} The composed object.
         */
        assignDefaults: function (dest, src) {
            return _.defaults(dest, src);
        },

        /**
         * Validates an object for mandatory properties.
         * @param obj The object to validate.
         * @param propsArr An array of the keys in obj that should be validated. If the object passed is not an
         * array, it is converted to such.
         */
        validateExists: function (obj, propsArr) {
            this._validateObj(obj, propsArr, function (fnObj, fnPropsArr) {
                var errMsgCause;
                _.forEach(fnPropsArr, function (key) {
                    if (!_.has(fnObj, key)) {
                        errMsgCause = '"' + key + '" property is missing';
                        return false;
                    }
                });
                return errMsgCause;
            });
        },

        /**
         * Validates an object for property types (does not check for existence).
         * @param obj The object to validate.
         * @param propsArr An array of the keys in obj that should be validated. If the object passed is not an
         * array, it is converted to such.
         */
        validateTypeArray: function (obj, propsArr) {
            this._validateObj(obj, propsArr, function (fnObj, fnPropsArr) {
                var errMsgCause;
                _.forEach(fnPropsArr, function (key) {
                    if (!_.isArray(fnObj[key])) {
                        errMsgCause = '"' + key + '" property must be of type array';
                    }
                });
                return errMsgCause;
            });
        },

        /**
         * Validates that a namespace is available in the context of an object.
         * @param context {Object} The object to test.
         * @param namespace {Array|String} A series of property names representing the lookup path, as an array.
         * A string can also used to pass a single property name instead of a namespace.
         * @param errMsgPrefix {String} (optional) A text to begin the error message with.
         */
        validateNamespace: function (context, namespace, errMsgPrefix) {
            var errMsgCause, ns = _.clone(namespace);
            if (_.isUndefined(context)) {
                errMsgCause = 'context must be defined to validate its namespace';
            }
            if (_.isUndefined(ns) || !_.isArray(ns) && !_.isString(ns)) {
                errMsgCause = 'namespace must be defined and of types Array or String';
            }
            if (_.isString(ns)) {
                ns = [ns];
            }
            if (!this._hasNamespace(context, ns)) {
                if (_.isUndefined(errMsgPrefix)) {
                    errMsgPrefix = '';
                } else {
                    errMsgPrefix += ' > ';
                }
                errMsgCause = errMsgPrefix + 'namespace "' + namespace.join('.') + '" is not available in context "' + context + '"';
            }

            if (errMsgCause) {
                this._fail(errMsgCause);
            }
        },

        /**
         * Checks if a namespace is available in the context of an object.
         * This function does not handle testing an empty array against the window object, i.e. hasNamespace(window, [])
         * is not supported (and will falsely return 'true').
         * @param context {Object} The object to test.
         * @param namespace {Array} A series of property names representing the lookup path, as an array.
         */
        _hasNamespace: function (context, namespace) {
            var prop = namespace.shift();
            return _.has(context, prop) && (_.isEmpty(namespace) || this._hasNamespace(context[prop], namespace));
        },

        _validateObj: function (obj, propsArr, fn) {
            var errMsgCause;
            if (_.isUndefined(obj)) {
                errMsgCause = 'obj must be defined';
            } else if (_.isUndefined(propsArr)) {
                errMsgCause = 'propsArr must be defined';
            } else if (_.isUndefined(fn) || !_.isFunction(fn)) {
                errMsgCause = 'fn must be defined and be of type Function';
            } else {
                // make sure propsArr is an array before passing it on
                if (!_.isArray(propsArr)) {
                    propsArr = [propsArr];
                }
                errMsgCause = fn.apply(fn, obj, propsArr);
            }

            if (errMsgCause) {
                this._fail('validation failed: ' + errMsgCause);
            }
        },

        _fail: function (errMsg) {
            logger.error(errMsg);
            logger.graph({ name: "UIComponents:FileUploadInputUtils:fail"});

            throw new Error(errMsg);
        }
    };
});
